import React from "react";

const ProductCards = ({
    image,
    name,
    metal,
    handleAddToCart, // Changed from onAddToCart to handleAddToCart
    productId,
    onOpenDetail
}) => {

    return (
        <div className="product-card">
            <img src={image} alt={name} onClick={onOpenDetail} className="product-image" />

            <div className="product-info">
                <h4 className="product-name">
                    {name} – <span className="metal-name">{metal}</span>
                </h4>

                <button
                    className="enquire-btn bg-primary"
                    onClick={handleAddToCart}
                    type="button"
                    aria-label={`Add ${name} to cart`}
                >
                    <i className="bx bx-cart-alt"></i>
                </button>
            </div>
        </div>
    );
};

export default ProductCards;